import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/AuthContext';
import { canAccessMentorship } from '../../../shared/lib/employeePortal';

/**
 * Guard khusus untuk akses halaman bimbingan.
 * Memastikan user memiliki hak akses bimbingan (Admin, Instruktur Karyawan, atau Siswa Karyawan level tertentu).
 */
export const RequireMentorshipAccess = () => {
    const { user, isAuthenticated } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!canAccessMentorship(user)) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};
